import React from "react";
import { trackEvent } from "../../lib/analytics";

const legalLinks = [
    {
        href: "/docs/01_Политика_обработки_персональных_данных.pdf",
        label: "Политика обработки персональных данных",
    },
    {
        href: "/docs/02_Согласие_на_обработку_персональных_данных.pdf",
        label: "Согласие на обработку персональных данных;",
    },
    {
        href: "/docs/03_Политика_куков.pdf",
        label: "Политика файлов-cookie;",
    },
] as const;

export function Footer() {
    const handleReportClick = () => {
        trackEvent("report_issue_click", { source: "footer" });
        window.openDriveeReport?.();
    };

    return (
        <>
            <footer className="mx-auto hidden w-full max-w-[1400px] items-center justify-between gap-6 px-6 pb-[68px] pt-40 text-sm text-muted min-[640px]:flex max-md:flex-col max-md:items-start max-md:pt-[100px]">
                <div className="flex flex-col gap-6">
                    <div className="flex flex-col items-start gap-2 text-[16px] leading-[1.25]">
                        {legalLinks.map((link) => (
                            <a
                                key={link.href}
                                href={link.href}
                                target="_blank"
                                rel="noreferrer"
                                className="text-inherit underline underline-offset-4"
                            >
                                — {link.label}
                            </a>
                        ))}
                    </div>
                    <span>
                        ©2026 Организатор ООО Ранго. Сайт разработан{" "}
                        <a href="https://smartom.dev" className="underline">
                            ООО СмартОм
                        </a>
                    </span>
                </div>
                <div className="flex items-center gap-6 max-md:flex-wrap">
                    <a
                        href="mailto:rungothecat@gmail.com"
                        className="text-inherit no-underline"
                        onClick={() =>
                            trackEvent("contact_email_click", { source: "footer_desktop" })
                        }
                    >
                        rungothecat@gmail.com
                    </a>
                    <a
                        href="tel:+79241744752"
                        className="text-inherit no-underline"
                        onClick={() =>
                            trackEvent("contact_phone_click", { source: "footer_desktop" })
                        }
                    >
                        +7 (924) 174-47-52
                    </a>
                    <button
                        type="button"
                        className="cursor-pointer bg-transparent text-inherit underline underline-offset-4"
                        onClick={handleReportClick}
                    >
                        Сообщить об ошибке
                    </button>
                    <a
                        className="inline-flex items-center justify-center gap-6 rounded-[37px] border border-white bg-transparent pb-[4px] pl-[13px] pr-[13px] pt-[4px] text-[24px] leading-7 font-medium tracking-[-0.04em] text-white uppercase no-underline transition hover:-translate-y-0.5 hover:bg-white hover:text-black"
                        href="https://t.me/driveecon"
                        target="_blank"
                        rel="noreferrer"
                        onClick={() =>
                            trackEvent("cta_subscribe_click", { source: "footer_desktop" })
                        }
                    >
                        ПОДПИШИСЬ НА КАНАЛ
                    </a>
                </div>
            </footer>
            <footer className="relative mx-auto mt-[24px] flex flex-col overflow-hidden px-4 py-6 text-center text-white min-[640px]:hidden">
                <div className="relative flex w-full flex-col items-center justify-between gap-2">
                    <div className="mb-3 flex w-full flex-col items-start gap-2 text-left text-[12px] leading-[1.4]">
                        {legalLinks.map((link) => (
                            <a
                                key={link.href}
                                href={link.href}
                                target="_blank"
                                rel="noreferrer"
                                className="text-white underline underline-offset-4"
                            >
                                — {link.label}
                            </a>
                        ))}
                    </div>
                    <a
                        href="mailto:rungothecat@gmail.com"
                        className="text-[12px] leading-7 font-medium tracking-[0] text-white no-underline"
                        onClick={() =>
                            trackEvent("contact_email_click", { source: "footer_mobile" })
                        }
                    >
                        rungothecat@gmail.com
                    </a>
                    <a
                        href="tel:+79241744752"
                        className="text-[12px] leading-7 font-medium tracking-[0] text-white no-underline"
                        onClick={() =>
                            trackEvent("contact_phone_click", { source: "footer_mobile" })
                        }
                    >
                        +7 (924) 174-47-52
                    </a>
                    <a
                        className="inline-flex  items-center justify-center gap-6 rounded-[37px] border border-white px-[13px] py-1 text-[16px] leading-7 font-medium uppercase tracking-[-0.04em] text-white no-underline"
                        href="https://t.me/driveecon"
                        target="_blank"
                        rel="noreferrer"
                        onClick={() =>
                            trackEvent("cta_subscribe_click", { source: "footer_mobile" })
                        }
                    >
                        ПОДПИШИСЬ НА КАНАЛ
                    </a>
                    <button
                        type="button"
                        className="bg-transparent text-[12px] leading-7 font-medium tracking-[0] text-white underline underline-offset-4"
                        onClick={handleReportClick}
                    >
                        Сообщить об ошибке
                    </button>
                    <span className="text-[12px] leading-7 font-medium tracking-[0] text-white">
                        ©2026 Организатор ООО Ранго. Сайт разработан{" "}
                        <a href="https://smartom.dev" className="underline">
                            ООО СмартОм
                        </a>
                    </span>
                </div>
            </footer>
        </>
    );
}
